import { TrayType } from '../types/content/custom.types';

//List of constant that are used in customPriceClasses
const MAX_CUSTOM_CLASSES_NAME_LENGTH = 32;
const MIN_CUSTOM_CLASS_TIER_VALUE = 0;
const MAX_CUSTOM_CLASS_TIER_VALUE = 1000000000000000;
const CLASS_EXISTS = 'Duplicate Class';
const LABEL_EXISTS = 'Label already exist';
const LABEL_REQUIRED = 'Label is required';
const OPTION_REQUIRED = 'Option is required';

const FEATURE_CUSTOMIZATION: TrayType = 'segment_feature';
const PRICE_CUSTOMIZATION: TrayType = 'segment_price';

const PRICES = { label: 'Price classes' };
const FEATURES = { label: 'Feature segments' };

export default {
  MAX_CUSTOM_CLASSES_NAME_LENGTH,
  MAX_CUSTOM_CLASS_TIER_VALUE,
  MIN_CUSTOM_CLASS_TIER_VALUE,
  CLASS_EXISTS,
  LABEL_EXISTS,
  FEATURE_CUSTOMIZATION,
  PRICE_CUSTOMIZATION,
  PRICES,
  FEATURES,
  LABEL_REQUIRED,
  OPTION_REQUIRED,
};
